<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h3 class="m-0">Adiantamentos</h3>
          <button
            class="btn btn-primary"
            @click="$router.push('/advances/add')"
          >
            <i class="fas fa-plus"></i> Solicitar adiantamento
          </button>
        </div>

        <base-crud
          :ref="'advancesCrud'"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableView="false"
          :enableDownload="true"
          :dataForm="dataForm"
          :extra="extra"
          @view="view"
          :customFilters="customFilters"
          @filtered_ds="filtered_ds"
          @edit="manage"
          @destroy="destroy"
          @fillExpenses="fillExpenses"
          @viewApprove="viewApprove"
          @manageRow="manageRow"
          @destroyRow="destroyRow"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import {
  ADVANCE_STATUS,
  ADVANCE_STATUS_LABELS,
  advanceStatusBadge,
} from "../../utils/expenseStatus";

export default {
  data: function () {
    return {
      customFilters: [
        {
          name: "date_f",
          type: "calendar",
          call: "filtered_ds",
        },
      ],
      date: "",
      table: "advancesTable",
      showMessageImport: false,
      advancesCrud: {},
      endPoint: "advances/",
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["user_id", "approve"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Colaborador",
          advance_amount: "Valor",
          is_dinner_advance: "Tipo",
          approve: "Status",
          date_f: "Data do Adiantamento",
          actions: "Ações",
        },
        sortable: ["id"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          approve: Object.keys(ADVANCE_STATUS_LABELS)
            .filter((id) => Number(id) !== 5)
            .map((id) => ({ id: Number(id), text: ADVANCE_STATUS_LABELS[id].text })),
        },
        templates: {
          approve: function (h, row) {
            const status = advanceStatusBadge(row.approve, row.accountability_result);
            return h("span", [
              h("span", { class: `badge ${status.badge}` }, status.text),
              row.is_contested ? h("span", { class: "badge badge-warning ml-50" }, "CONTESTADO") : null,
            ]);
          },
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          advance_amount: function (h, row) {
            return new Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(row.advance_amount || 0);
          },
          is_dinner_advance: function (h, row) {
            if (row.is_dinner_advance) {
              return h(
                "span",
                {
                  class: "badge badge-info",
                },
                "Jantar"
              );
            } else {
              return h(
                "span",
                {
                  class: "badge badge-secondary",
                },
                "Normal"
              );
            }
          },
          date_f: function (h, row) {
            // O backend já retorna a data formatada no padrão brasileiro (dd/mm/yyyy)
            return row.date_f || "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;

          if (
            this.$parent.$parent.$parent.date != null &&
            this.$parent.$parent.$parent.date != ""
          ) {
            requestData.params.date = this.$parent.$parent.$parent.date;
          }

          requestData.params.query = "";
          requestData.params.with = ["user"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      columns: [
        "id",
        "user_id",
        "advance_amount",
        "is_dinner_advance",
        "approve",
        "date_f",
        "actions",
      ],
      dataForm: {},
    };
  },
  methods: {
    filtered_ds(date) {
      this.date = date;
    },
    manage(props, row, index) {
      // Gerenciar adiantamento (apenas admin)
      this.$router.push(`/advances/edit/${row.id}`);
    },
    fillExpenses(data) {
      // Preencher despesas do adiantamento
      if (data && data.row && data.row.id) {
        this.$router.push(`/reimbursement_solicitations/edit/${data.row.id}`);
      }
    },
    viewApprove(data) {
      // Visualizar/Aprovar adiantamento
      if (data && data.row && data.row.id) {
        this.$router.push(`/advances/view/${data.row.id}`);
      }
    },
    manageRow(data) {
      if (data && data.row && data.row.id) {
        this.$router.push(`/advances/edit/${data.row.id}`);
      }
    },
    destroyRow(data) {
      if (data && data.row) {
        this.destroy(null, data.row);
      }
    },
    destroy(props, row, index) {
      const self = this;
      swal({
        title: "Deseja deletar o registro?",
        text: "Essa ação irá deletar também a solicitação de reembolso vinculada a ela. Essa operação não pode ser desfeita.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, deletar!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
            className: "btn-success",
          },
        },
      }).then(function (result) {
        switch (result) {
          case "cancel":
            swal("Cancelado", "O registro não foi excluido!", "info");
            break;
          case "confirm":
            axios
              .delete(self.$store.state.api + "advances/" + row.id, {
                headers: {
                  Authorization: `Bearer ${self.$store.state.token}`,
                },
              })
              .then(function (response) {
                self.$refs.advancesCrud.$refs.table.refresh();
                swal("Sucesso", "Registro excluído com sucesso!", "success");
              })
              .catch(function (error) {
                let errorMessage = "Erro ao excluir registro";
                if (
                  error.response &&
                  error.response.data &&
                  error.response.data.message
                ) {
                  errorMessage = error.response.data.message;
                }
                swal("Erro", errorMessage, "error");
              });
            break;
          default:
        }
      });
    },
    view(props, row, index) {
      this.$router.push(`/advances/view/${row.id}`);
    },
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        approve: "approve",
        advance_amount: "advance_amount",
      };
      let filters = "&orderByDesc=id&with[]=reimbursements&with[]=user&";

      $.each(query, function (index, value) {
        if (index === "approve" && value === "preenchido") {
          // Filtro especial para "Preenchido"
          filters += "has_reimbursements=1&";
        } else if (index === "advance_amount" && value) {
          // Filtro de valor
          filters += "advance_amount_filter=" + value + "&";
        } else if (value) {
          filters += columns[index] + "=" + value + "&";
        }
      });

      return filters;
    },
  },
  components: {
    BaseCrud,
  },
  computed: {
    isAccessNivel() {
      return (
        this.$store.state.user.perfil_id === 8 ||
        this.$store.state.user.perfil_id === 7
      );
    },
    extra() {
      const self = this;
      const isAdmin = this.isAccessNivel;
      const isWaitingApproval = (row) => Number(row.approve) === ADVANCE_STATUS.WAITING_APPROVAL;

      const buttons = [
        {
          id: 1,
          label: "",
          class: "btn btn-crud fill-expenses margin-crud",
          title: "Preencher Despesas",
          name: "fillExpenses",
          icon: "fas fa-receipt",
          showIf: (row) => {
            // Só o próprio colaborador, no status 4 (Aguardando Prestação de Contas)
            return (
              Number(row.approve) === ADVANCE_STATUS.WAITING_ACCOUNTABILITY &&
              Number(row.user_id) === Number(self.$store.state.user.id)
            );
          },
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud view margin-crud",
          title: "Visualizar",
          name: "viewApprove",
          icon: "fas fa-eye",
          showIf: (row) => {
            return true;
          },
        },
        {
          id: 3,
          label: "",
          class: "btn btn-crud edit margin-crud",
          title: "Editar",
          name: "manageRow",
          icon: "fas fa-edit",
          showIf: (row) => isAdmin && isWaitingApproval(row),
        },
        {
          id: 4,
          label: "",
          class: "btn btn-crud delete margin-crud",
          title: "Excluir",
          name: "destroyRow",
          icon: "fas fa-trash",
          showIf: (row) => isAdmin && isWaitingApproval(row),
        },
      ];

      return buttons;
    },
  },
};
</script>
